<template>
  <v-container grid-list-xl text-left class="elevation-6 mt-3">
    <v-layout row wrap justify-space-between>
      <v-flex xs12>
        <p class="title" :style="{textAlign: 'center', textTransform: 'uppercase'}">Шаблон Анкеты</p>
        <p :style="{position: 'relative', marginTop: '-20px'}">
          <v-btn absolute dark fab small right top @click="addField" color="secondary" v-if="accesses['form-template_update']">
            <v-icon>add</v-icon>
          </v-btn>
        </p>
      </v-flex>
      <v-flex xs12 md5>
        <p>Фото</p>
      </v-flex>

      <v-flex xs12 md7>
        <p class="bottom-border my-2" v-for="(field, index) in default_fields" :key="index">
          {{field.name}}
        </p>
      </v-flex>

    </v-layout>

 
      <draggable v-model="user_fields" class="layout row wrap" @end="isDirty=true">
        <v-flex xs12 md6 v-for="(field, index) in user_fields" :key="index">
          <v-card flat class="bottom-border ovhide" justify-center>
            <span>{{field.name}}</span>
            <v-btn flat icon fab small dark color="warning" class="pull-right ma-0 pa-0" @click="editField(index)">
              <v-icon>edit</v-icon>
            </v-btn>
          </v-card>
        </v-flex>
      </draggable>

    <v-layout row wrap v-if="editing" class="blue-grey lighten-5 mt-3">
      <v-flex xs12 class="py-0 my-0">
        <p class="subheading mt-3 mb-0 ml-1 pull-left">{{this.field_edit_index==null?'Добавить поле':'Редактировать поле'}}</p>
        <v-btn icon class="pull-right" @click="editing=false"><v-icon>close</v-icon></v-btn>
      </v-flex>
      <v-flex xs12 md4 class="py-0 my-0">
        <v-text-field
          class="mt-3"
          v-model="fieldLabel"
          label="Название поля"
          :error-messages="veeErrors.collect('Название поля')"
          v-validate="'required'"
          data-vv-name="Название поля"
          required
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md4 class="py-0 my-0">
        <v-select
          class="mt-3"
          v-model="field_editing"
          :items="field_types"
          label="Тип поля"
          :error-messages="veeErrors.collect('Тип поля')"
          v-validate="'required'"
          data-vv-name="Тип поля"
          item-value="type"
          required
          return-object
          no-data-text="Нет доступных полей"></v-select>
      </v-flex>
      <v-flex xs12 md4 v-if="field_editing.type==='select' || field_editing.type==='multiselect'" class="text-xs-right py-0 my-0">
        <v-text-field
          v-for="(field,index) in field_editing.options.items"
          v-model="field.value"
          :label="'Вариант '+(index+1)"
          append-icon="delete"
          @click:append="() => deleteFieldOption(index)"
          :key="index"
          hide-details
          :class="{'mt-3': index===0}"
        ></v-text-field>
        <a @click="addOption" style="display: block;margin-top: 10px">Добавить вариант</a>
      </v-flex>
      <v-flex xs8 offset-xs2 md2 offset-md5>
        <v-btn color="success" small dark @click="saveField">{{addBtnText}}</v-btn>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex xs12 class="text-xs-center">
        <v-btn
          color="info"
          :loading="saving"
          @click.native="saveAnketa"
          :disabled="saving"
          v-if="isDirty && accesses['form-template_update']"
        >
          Сохранить шаблон
          <span slot="loader">Сохранение...</span>
        </v-btn>

      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
  import draggable from 'vuedraggable'
  
  export default {
    name: 'AnketaTemplate',
    
    components: {
      draggable
    },
    
    data() {
      return {
        user_fields: [],
        default_fields: [],
        editing: false,
        fieldLabel: '',
        field_editing: {},
        field_types:[
          {
            type: 'string',
            text: 'Однострочный текст',
            component: 'v-text-field',
            options:{
              type:'text',
            }
          },
          {
            type: 'number',
            text: 'Число',
            component: 'v-text-field',
            options:{
              type:'number',
            }
          },
          {
            type: 'text',
            text: 'Многострочный текст',
            component: 'v-textarea',
            options:{
              // 'multi-line': true,
              'rows': 3
            },
          },
          {
            type: 'select',
            text: 'Выпадающий список',
            component: 'v-select',
            options:{
              itemText: 'value',
              multiple: false,
              items: []
            }
          },
          {
            type: 'multiselect',
            text: 'Список с множественным выбором',
            component: 'v-select',
            options:{
              itemText: 'value',
              multiple: true,
              items: []
            }
          },
          {
            type: 'checkbox',
            text: 'Чекбокс',
            component: 'v-checkbox',
          },
          {
            type: 'dateС',
            text: 'Дата(с календарем)',
            component: 'd-date-picker',
            options: {}
          },
          {
            type: 'date',
            text: 'Дата(без календаря)',
            component: 'v-text-field',
            options: {
              mask: '##.##.####',
              'return-masked-value': true,
            }
          },
          {
            type: 'time',
            text: 'Время',
            component: 'v-text-field',
            options: {
              mask: '##:##:##',
              'return-masked-value': true,
            }
          },
          {
            type: 'datetime',
            text: 'Дата и время',
            component: 'v-text-field',
            options: {
              mask: '##.##.#### ##:##:##',
              'return-masked-value': true,
            }
          }
        ],
        field_edit_index: null,
        saving: false,
        isDirty: false,
      }
    },

    computed:{
      addBtnText() {
        return (this.field_edit_index==null) ? 'Добавить' : 'Сохранить'
      },
      accesses() {
        return this.$store.state.app.account.accesses['worksheet'] || []
      }
    },

    created() {
      if (!this.accesses['form-template_access']) {
        this.$store.commit(`app/layout/setRouteStatus`, 'accessDenied')
      }
      this.getFields()
    },

    methods: {
      getFields() {
        this.$store.dispatch('orgstructure/anketa/getTemplate').then(response => {
          this.default_fields = response.default_fields
          this.user_fields = response.other_fields
        })
      },
  
      addOption() {
        this.field_editing.options.items.push({
          value: ''
        })
      },
      
      deleteFieldOption(index) {
        this.field_editing.options.items.splice(index, 1)
      },
  
      addField() {
        this.field_edit_index = null
        this.field_editing = {}
        this.fieldLabel = ''
        this.editing = true
      },
  
      saveField() {
        this.$validator.validateAll().then( result => {
          if (result) {
            let field = this.field_editing
            field.name = this.fieldLabel
            if(this.field_edit_index!=null){
              this.user_fields[this.field_edit_index] = field
            } else {
              this.user_fields.push(field)
            }
            this.$nextTick(() => {
              this.$validator.reset()
            })
            this.field_edit_index = null
            this.field_editing = {}
            this.fieldLabel = ''
            this.isDirty = true
            return
          }
        })
      },

      saveAnketa() {
        this.saving = true
        this.$store.dispatch('orgstructure/anketa/updateTemplate', this.user_fields).then(response => {
          this.saving = false
          this.isDirty = false
        }).catch( error => {
          this.saving = false
        })
      },

      editField(index){
        this.field_editing = this.user_fields[index]
        this.fieldLabel = this.user_fields[index].name
        this.editing = true
        this.field_edit_index = index
      },

      deleteField(index){
        /*
        if(index===this.field_edit_index){
          this.field_editing = {}
          this.$nextTick(() => this.$validator.reset())
        }
        this.user_fields.splice(index, 1)
        */
      }
    },

  }
</script>

<style>
  .bottom-border{
    border-bottom: 1px solid #cccccc;
  }
  .ovhide{
    overflow: hidden;
  }
</style>


// WEBPACK FOOTER //
// src/apps/org/components/Anketa/AnketaTemplate.vue